<template>
  <div class="sf-accordion">
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
import { provide, onBeforeMount } from 'vue'

import { useAccordion } from '@app/shared/pinia/accordion'
import getPiniaInstance from '@app/shared/pinia/instance'

interface Props {
  accordionId: string
  activeIndex: string
}

const props = defineProps<Props>()

const accordionStore = useAccordion(getPiniaInstance())

provide('accordionId', props.accordionId)

onBeforeMount(() => {
  accordionStore.toggleIndex(props.activeIndex, props.accordionId)
})
</script>

<style lang="scss" scoped>
@import '@app/shared/vue/components/sf-accordion/sf-accordion';
</style>
